import { render, staticRenderFns } from "./IndicadoresResumoArmazemExterna.vue?vue&type=template&id=57afefd5&scoped=true&"
import script from "./IndicadoresResumoArmazemExterna.vue?vue&type=script&lang=js&"
export * from "./IndicadoresResumoArmazemExterna.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresResumoArmazemExterna.vue?vue&type=style&index=0&id=57afefd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57afefd5",
  null
  
)

export default component.exports